export default ({ $axios }) => ({
  listVideos: async (query = {}) => {
    try {
      const { data } = await $axios.get('/v3/app/video', {
        params: {
          isFoodSolutionContent: true,
          ...query,
        },
      })
      return data
    } catch (error) {
      console.error('Error listing food solution videos', error)
      throw error
    }
  },
  listLinks: async (query = {}) => {
    try {
      const { data } = await $axios.get('/v3/app/link', {
        params: {
          onlyFoodSolutionContent: true,
          ...query,
        },
      })
      return data
    } catch (error) {
      console.error('Error listing food solution links', error)
      throw error
    }
  },
  listFiles: async (query = {}) => {
    try {
      const { data } = await $axios.get('/v3/app/appfiles', {
        params: {
          ...query,
          type: 'foodsolution',
        },
      })
      return data
    } catch (error) {
      console.error('Error listing food solution files', error)
      throw error
    }
  },
})
